// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/new_img/hero_bannerbg2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/new_img/get_standerdbg_after.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/new_img/get_standerdbg_before.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/images/new_img/ctabg_after.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.herobanner2 .scan_block {
  background-color: #0C0900;
  margin: -10px auto;
}

.banner_add_slide {
  margin: 80px 0px 60px;
  position: relative;
  z-index: 6666;
}

.banner_add_slide .heighlightcnt img {
  border-radius: 13px;
}

.banner_add_slide .slick-dots li button:before {
  font-size: 0px;
  background-color: #FFFBFB;
  left: 0;
  width: 10px;
  border-radius: 50px;
  height: 10px;
}

body .banner_add_slide .slick-dots li.slick-active button:before {
  width: 24px;
  background-color: #F3BB2B;
}

#popup-box.popup-box.homepop_box {
  width: 700px;
  animation: lp-pop-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@keyframes lp-pop-in {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  #popup-box.popup-box.homepop_box {
    animation: none !important;
  }
}

body .banner_add_slide .slick-dots li button {
  width: auto;
  height: auto;
}

body .banner_add_slide .slick-dots li {
  width: auto;
  height: auto;
}

body .banner_add_slide .slick-dots li.slick-active {
  width: 24px;
}


.herobanner2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
}

/* —— Hero banner image (hero_section_main): glow + float + reveal —— */
.hero_section_main .banner_img {
  position: relative;
  z-index: 1;
}

.hero_section_main .banner_img_main {
  position: relative;
  transform-style: preserve-3d;
}

.hero_section_main .banner_img_main::before {
  content: "";
  position: absolute;
  inset: -10% -6% -6% -6%;
  z-index: 0;
  pointer-events: none;
  background: radial-gradient(ellipse 70% 60% at 50% 58%,
      rgba(209, 170, 103, 0.28) 0%,
      rgba(209, 170, 103, 0.06) 45%,
      transparent 72%);
  filter: blur(2px);
  animation: bannerHeroGlow 5s ease-in-out infinite;
}

.hero_section_main .banner_img_motion {
  position: relative;
  z-index: 1;
  transform-origin: 50% 60%;
  animation: bannerHeroFloat 7s ease-in-out infinite;
}

.hero_section_main .banner_img_motion img {
  display: block;
  width: 100%;
  height: auto;
  animation: bannerHeroReveal 1s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes bannerHeroReveal {
  from {
    opacity: 0;
    filter: blur(6px);
  }

  to {
    opacity: 1;
    filter: blur(0);
  }
}

@keyframes bannerHeroFloat {

  0%,
  100% {
    transform: translateY(0) rotate(0deg) scale(1);
  }

  40% {
    transform: translateY(-14px) rotate(0.75deg) scale(1.012);
  }

  65% {
    transform: translateY(-6px) rotate(-0.45deg) scale(1.004);
  }
}

@keyframes bannerHeroGlow {

  0%,
  100% {
    opacity: 0.75;
    transform: scale(0.96);
  }

  50% {
    opacity: 1;
    transform: scale(1.04);
  }
}

@media (prefers-reduced-motion: reduce) {

  .hero_section_main .banner_img_main::before,
  .hero_section_main .banner_img_motion {
    animation: none !important;
  }

  .hero_section_main .banner_img_motion img {
    animation: none !important;
    opacity: 1;
    filter: none;
  }
}

.how_get_account_ot ul li p {
  font-size: 22px;
}

.herobanner2 .banner_cnt {
  padding-top: 100px;
}

.herobanner2 .banner_cnt h3 {
  font-size: 35px;
  font-weight: 400;
  text-transform: capitalize;
}

.herobanner2 .banner_cnt h1 span {
  color: #f3bb2b;
}

.uptates_sm.market_update_outer h2 span {
  color: #f3bb2b;
}

.uptates_sm .trade_btn button {
  display: flex;
  align-items: center;
  gap: 24px;
}

.services_block h4 {
  font-size: 24px;
  font-weight: 600;
}

.services_block p {
  line-height: 24px;
}

.started_trading_s {
  position: relative;
}

.started_trading_s::before {
  position: absolute;
  right: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 28%;
  background-repeat: no-repeat;
  background-position: right;
  top: -620px;
  z-index: 333;
  left: inherit;
  width: 100%;
}

.started_trading_s .how_get_account_ot .trade_btn button {
  display: flex;
  align-items: center;
  gap: 24px;
}

.started_trading_s .trading_platform_section {
  background-color: transparent;
  position: relative;
  z-index: 666;
}

.started_trading_s .trading_platform_section h2 span {
  color: #f3bb2b;
  display: inline;
  padding-right: 10px;
}

.started_trading_s .services_block:hover {
  background-color: transparent;
}

.started_trading_s::after {
  position: absolute;
  left: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 40%;
  background-repeat: no-repeat;
  background-position: left bottom;
  bottom: -300px;
  z-index: 333;
  right: inherit;
  width: 100%;
  opacity: 0.6;
}

body.light_theme .rounded_effect_bottom {
  opacity: 0.2;
}

.started_trading_s .how_get_account_ot {
  z-index: 666;
  position: relative;
  background-image: none !important;
  background-color: transparent;
}


.how_get_account_ot h2 span {
  color: #f3bb2b;
}

.newhome_maximizeprofit_s h2 {
  letter-spacing: -1px;
}

.newhome_maximizeprofit_s {
  z-index: 666;
  background-color: transparent;
}

.newhome_maximizeprofit_s h2 span {
  color: #f3bb2b;
}

.newhome_maximizeprofit_s .right_costs_rg ul li {
  color: #f3bb2b;
}

.newhome_maximizeprofit_s .cta_register_s ul.social_media {
  margin: 100px 0px 20px;
}

.newhome_maximizeprofit_s .trade_btn button {
  display: flex;
  gap: 18px;
  align-items: center;
  border: 1px solid #f3bb2b;
  color: #f3bb2b;
}

.newhome_maximizeprofit_s ul.social_media a {
  background-color: #f3bb2b;
}

.newhome_maximizeprofit_s button.learnbtn a {
  background-color: #f3bb2b;
}

.newhome_maximizeprofit_s .profit_cost_cnt {
  padding: 0px 0px 0px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #111;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* * {
  scrollbar-width: thin;
  scrollbar-color: #333 #111;
} */


.newhome_maximizeprofit_s::after {
  position: absolute;
  right: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 600px;
  background-repeat: no-repeat;
  background-position: right top;
  top: -27%;
  z-index: 333;
  left: inherit;
  width: 100%;
}

.newhome_maximizeprofit_s .container {
  position: relative;
  z-index: 666;
}

.row.cta_register_s {
  align-items: center;
}

.newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {
  padding-top: 40px;
}

.newhome_maximizeprofit_s .trusted_partner {
  padding: 100px 0px;
}

.vector_currency.one {
  top: 0px;
}

.banner_animation_vector.rightside .vector_currency.one {
  top: 0px;
}


body.light_theme .herobanner2 .scan_block {
  background-color: #f5f5f5;
}

body.light_theme .join_group_s button.joinbtn {
  color: #222222;
}

body.light_theme .herobanner2 button.morebtn {
  color: #222;
}

body.light_theme .herobanner2 .scan_cnt {
  color: #222;
}

body.light_theme .herobanner2 .banner_cnt .scan_block p {
  color: #222;
}

body.light_theme .banner_add_slide .slick-dots li button:before {
  background-color: #747474;
}

.market_update_outer .container {
  position: relative;
  z-index: 666;
}

body.light_theme .how_get_account_ot.bgtransparrent_s {
  background-color: transparent;
}

body.light_theme .profit_costs_cta_outer.newhome_maximizeprofit_s {
  background-color: transparent;
}

body.light_theme .started_trading_s .how_get_account_ot {
  background-color: transparent;
}

body.light_theme .trading_platform_section h2 {
  color: #0C0900;
}

body.light_theme .services_block {
  border: 1px solid #dddddd;
  background-color: #f5f5f5;
  color: #000;
}

body.light_theme .services_block p {
  color: #000;
}

body.light_theme .faq_cta_outer .accordion-item {
  color: #141414;
}

body.light_theme .faq_cta_outer .accordion-item h3 button.accordion-button {
  color: #141414;
  border-bottom: 1px solid #a9a9a9;
}

body.light_theme .faq_cta_outer .accordion-item .collapse.show {
  background-color: #f5f5f5;
}

body.light_theme .faq_cta_outer .accordion-item.active h3 button.accordion-button[aria-expanded="true"] {
  background-color: #f5f5f5;
  border-color: #f5f5f5 !important;
}

img.light_m {
  display: none;
}

body.light_theme img.light_m {
  display: flex;
  margin: 0 auto;
}

body.light_theme img.drak_d {
  display: none;
}

body.light_theme .scan_left_s img.light_m {
  margin-left: 0px;
  margin: inherit;
}


.herobanner2 .scan_block {
  background-color: #0C0900;
  margin: -10px auto;
}

.banner_add_slide {
  margin: 80px 0px 60px;
  position: relative;
  z-index: 6666;
}

.banner_add_slide .heighlightcnt img {
  border-radius: 13px;
}

.banner_add_slide .slick-dots li button:before {
  font-size: 0px;
  background-color: #FFFBFB;
  left: 0;
  width: 10px;
  border-radius: 50px;
  height: 10px;
}

body .banner_add_slide .slick-dots li.slick-active button:before {
  width: 24px;
  background-color: #F3BB2B;
}

body .banner_add_slide .slick-dots li button {
  width: auto;
  height: auto;
}

body .banner_add_slide .slick-dots li {
  width: auto;
  height: auto;
}

body .banner_add_slide .slick-dots li.slick-active {
  width: 24px;
}


.herobanner2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
}

.how_get_account_ot ul li p {
  font-size: 22px;
}

.herobanner2 .banner_cnt {
  padding-top: 100px;
}

.herobanner2 .banner_cnt h3 {
  font-size: 40px;
  font-weight: 400;
  text-transform: capitalize;
}

.herobanner2 .banner_cnt h1 span {
  color: #f3bb2b;
}

.uptates_sm.market_update_outer h2 span {
  color: #f3bb2b;
}

.uptates_sm .trade_btn button {
  display: flex;
  align-items: center;
  gap: 24px;
}

.services_block {
  font-family: "Afacad", sans-serif;
}

.services_block h4 {
  font-size: 24px;
  font-weight: 600;
}

.services_block p {
  line-height: 24px;
}


.started_trading_s {
  position: relative;
}

.started_trading_s::before {
  position: absolute;
  right: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 28%;
  background-repeat: no-repeat;
  background-position: right;
  top: -620px;
  z-index: 333;
  left: inherit;
  width: 100%;
}

.started_trading_s .how_get_account_ot .trade_btn button {
  display: flex;
  align-items: center;
  gap: 24px;
}

.started_trading_s .trading_platform_section {
  background-color: transparent;
  position: relative;
  z-index: 666;
}

.started_trading_s .trading_platform_section h2 span {
  color: #f3bb2b;
  display: inline;
  padding-right: 10px;
}

.started_trading_s .services_block:hover {
  background-color: transparent;
}

.started_trading_s::after {
  position: absolute;
  left: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 40%;
  background-repeat: no-repeat;
  background-position: left bottom;
  bottom: -300px;
  z-index: 333;
  right: inherit;
  width: 100%;
  opacity: 0.6;
}

body.light_theme .rounded_effect_bottom {
  opacity: 0.2;
}

.started_trading_s .how_get_account_ot {
  z-index: 666;
  position: relative;
  background-image: none !important;
  background-color: transparent;
}


.how_get_account_ot h2 span {
  color: #f3bb2b;
}

.newhome_maximizeprofit_s h2 {
  letter-spacing: -1px;
}

.newhome_maximizeprofit_s {
  z-index: 666;
  background-color: transparent;
}

.newhome_maximizeprofit_s h2 span {
  color: #f3bb2b;
}

.newhome_maximizeprofit_s .right_costs_rg ul li {
  color: #f3bb2b;
}

.newhome_maximizeprofit_s .cta_register_s ul.social_media {
  margin: 100px 0px 20px;
}

.newhome_maximizeprofit_s .trade_btn button {
  display: flex;
  gap: 18px;
  align-items: center;
  border: 1px solid #f3bb2b;
  color: #f3bb2b;
}

.newhome_maximizeprofit_s ul.social_media a {
  background-color: #f3bb2b;
}

.newhome_maximizeprofit_s button.learnbtn a {
  background-color: #f3bb2b;
}

.newhome_maximizeprofit_s .profit_cost_cnt {
  padding: 0px 0px 0px;
}


.newhome_maximizeprofit_s::after {
  position: absolute;
  right: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 600px;
  background-repeat: no-repeat;
  background-position: right top;
  top: -27%;
  z-index: 333;
  left: inherit;
  width: 100%;
}

.newhome_maximizeprofit_s .container {
  position: relative;
  z-index: 666;
}

.row.cta_register_s {
  align-items: center;
}

.newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {
  padding-top: 40px;
}

.newhome_maximizeprofit_s .trusted_partner {
  padding: 100px 0px;
}

.vector_currency.one {
  top: 0px;
}

.banner_animation_vector.rightside .vector_currency.one {
  top: 0px;
}


body.light_theme .herobanner2 .scan_block {
  background-color: #f5f5f5;
}

body.light_theme .join_group_s button.joinbtn {
  color: #222222;
}

body.light_theme .herobanner2 button.morebtn {
  color: #222;
}

body.light_theme .herobanner2 .scan_cnt {
  color: #222;
}

body.light_theme .herobanner2 .banner_cnt .scan_block p {
  color: #222;
}

body.light_theme .banner_add_slide .slick-dots li button:before {
  background-color: #747474;
}

.market_update_outer .container {
  position: relative;
  z-index: 666;
}

body.light_theme .how_get_account_ot.bgtransparrent_s {
  background-color: transparent;
}

body.light_theme .profit_costs_cta_outer.newhome_maximizeprofit_s {
  background-color: transparent;
}

body.light_theme .started_trading_s .how_get_account_ot {
  background-color: transparent;
}

body.light_theme .trading_platform_section h2 {
  color: #0C0900;
}

body.light_theme .services_block {
  border: 1px solid #dddddd;
  background-color: #f5f5f5;
  color: #000;
}

body.light_theme .services_block p {
  color: #000;
}

body.light_theme .faq_cta_outer .accordion-item {
  color: #141414;
}

body.light_theme .faq_cta_outer .accordion-item h3 button.accordion-button {
  color: #141414;
  border-bottom: 1px solid #a9a9a9;
}

body.light_theme .faq_cta_outer .accordion-item .collapse.show {
  background-color: #f5f5f5;
}

body.light_theme .faq_cta_outer .accordion-item.active h3 button.accordion-button[aria-expanded="true"] {
  background-color: #f5f5f5;
  border-color: #f5f5f5 !important;
}

img.light_m {
  display: none;
}

body.light_theme img.light_m {
  display: flex;
  margin: 0 auto;
}

body.light_theme img.drak_d {
  display: none;
}

body.light_theme .scan_left_s img.light_m {
  margin-left: 0px;
  margin: inherit;
}





@media screen and (max-width:1440px) {

  .hero_section.herobanner2 {
    height: 100%;
    min-height: 100%;
    padding-top: 20px;
    padding-bottom: 15px;
  }

  .banner_animation_vector {
    top: 90px;
  }

  .hero_section.herobanner2 .slick-track {
    gap: 20px;
  }

  .banner_add_slide {
    margin: 60px 0px 40px;
  }

  .rounded_effect_bottom {
    bottom: 190px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s {
    margin-top: 80px;
  }

}

@media screen and (max-width:1200px) {

  .trading_img {
    width: 110px;
  }

  .newhome_maximizeprofit_s::after {
    background-size: 400px;
    top: -15%;
  }

  .how_get_account_ot ul li p {
    font-size: 18px;
  }


}

@media screen and (max-width:991px) {

  .banner_img {
    width: 50%;
  }

  .herobanner2 .banner_cnt h3 {
    font-size: 30px;
  }

  .herobanner2 .banner_cnt h1 {
    font-size: 24px;
  }

  .newhome_maximizeprofit_s .trusted_partner {
    padding: 60px 0px;
  }


}


/* Landing — Trending cards: ticker + subtext + USD price + % (stacked) */
.trending_crypto .td_first.landing_pair_row {
  align-items: center;
  gap: 12px;
}

.trending_crypto .landing_pair_names {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  text-align: left;
}

.trending_crypto .landing_pair_symbol {
  font-size: 16px;
  font-weight: 600;
  color: #eaecef;
  line-height: 1.2;
}

.trending_crypto .landing_pair_sub {
  font-size: 13px;
  font-weight: 300;
  padding-top: 3px;
  color: #848e9c;
  line-height: 1.2;
}

.trending_crypto .landing_pair_price_stack {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.trending_crypto .landing_pair_price {
  font-size: 16px;
  font-weight: 600;
  color: #eaecef;
}

.trending_crypto .landing_pair_chg {
  font-size: 15px;
  font-weight: 500;
  line-height: 1.2;
}

.trending_crypto .landing_pair_chg.green {
  color: #5eba89;
}

.trending_crypto .landing_pair_chg.red {
  color: #F65454;
}

/* Mobile / tablet: tab strip (style.css hides non-.active panels ≤991px) */
.trending_crypto_tabs {
  display: none;
}

@media screen and (max-width: 991.98px) {
  .trending_crypto_tabs {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: nowrap;
    gap: 20px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 8px;
  }

  .trending_crypto_tabs button {
    flex: inherit;
    ;
    min-width: 0;
    margin: 0;
    padding: 8px 0px;
    font-size: 15px;
    position: relative;
    font-weight: 400;
    line-height: 1.2;
    /* border-radius: 50px; */
    border: none;
    background: none;
    color: #8f8f8f;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  }

  body.light_theme .trending_crypto_tabs button {
    color: #444;
  }

  .trending_crypto_tabs button:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 18px;
    height: 2.5px;
    right: 0px;
    background: #ebebeb;
    margin: 0 auto;
    border-radius: 20px;
    opacity: 0;
  }

  body.light_theme .trending_crypto_tabs button:before {
    background: #000000;
  }

  .trending_crypto_tabs button.active:before {
    opacity: 1;
  }

  .trending_crypto_tabs button.active {
    color: #fff;
  }

  .viewmorebtn a {
    font-size: 16px;
  }

  .banner_bottom_vector {
    display: none;
  }

}

body.light_theme .trending_crypto_tabs button {
  color: #84888c;
}

body.light_theme .trending_crypto_tabs button.active {
  color: #000000;
}

/* .trending_crypto .hot_spot_outer.hot_spot_outer--highlight {
  border: 2px solid #3b82f6;
  box-shadow: 0 8px 28px rgba(59, 130, 246, 0.15);
} */

body.light_theme .trending_crypto .landing_pair_symbol,
body.light_theme .trending_crypto .landing_pair_price {
  color: #0D0D0D;
}

body.light_theme .trending_crypto .landing_pair_sub {
  color: #6b7280;
}

/* Promo banner strip — react-slick (gold pill active dot, grey dots) */
.cardbnr_crypto_section {
  padding: 20px 0 24px;
  background: #000;
}

body.light_theme .cardbnr_crypto_section {
  background: #f6f6f6;
}

.cardbnr_crypto_slide .cardbnr_crypto_slick.slick-slider {
  margin-bottom: 0;
}

/* ~12px gap between cards (screenshot-style tight strip) */
.cardbnr_crypto_slide .slick-list {
  margin: 0 -6px;
}

.cardbnr_crypto_slide .slick-slide {
  height: auto;
}

.cardbnr_crypto_slide .slick-slide>div {
  padding: 0 6px;
}

.cardbnr_slide_inner {
  border-radius: 16px;
  overflow: hidden;
  line-height: 0;
}

.cardbnr_slide_inner img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* Dots: always visible (override global slick / theme opacity) */
.cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots,
.cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots {
  position: relative;
  bottom: auto;
  left: auto;
  right: auto;
  margin: 24px 0 0;
  padding: 8px 0 0;
  width: 100%;
  display: flex !important;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0;
  list-style: none;
  z-index: 2;
}

.cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li,
.cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li {
  width: auto;
  height: auto;
  margin: 0 4px;
  opacity: 1 !important;
}

.cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li button,
.cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li button {
  width: 30px;
  height: 12px;
  padding: 0;
  position: relative;
  opacity: 1 !important;
}

.cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li button:before,
.cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li button:before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #a8a9b0;
  opacity: 1 !important;
  font-size: 0;
  line-height: 0;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12);
}

.cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li.slick-active button:before,
.cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li.slick-active button:before {
  width: 26px;
  height: 8px;
  border-radius: 999px;
  background: #D1AA67;
}

body.light_theme .cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li button:before,
body.light_theme .cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li button:before {
  background: #bfc1c9b0;
}

body.light_theme .cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li.slick-active button:before,
body.light_theme .cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li.slick-active button:before {
  background: #D1AA67;
}

/* —— Trade & Earn: interactive hub (rotating arc + active cards) —— */
.trade_earn_section {
  max-height: none !important;
  padding-bottom: 4rem !important;
}

.features-hub.features-card {
  background-color: #171a20;
  border-radius: 2rem;
  padding: 2rem 1rem 3rem;
  margin-top: 40px;
}

body.light_theme .features-hub.features-card {
  background-color: #fff;
}

button.feature-item {
  display: block;
  width: 100%;
  text-align: left;
  min-height: 124px;
  background: #ffffff14;
  border: 1px solid #cecfd021;
  border-radius: 16px;
  padding: 1.25rem 1.35rem;
  text-align: center;
  margin-bottom: 32px;
  cursor: pointer;
  transition: background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
  color: #d9d9d9;
}

body.light_theme button.feature-item {
  background: #fff;
  border: 1px solid #CECFD0;
  color: #878787;
}

button.feature-item h3 {
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 0.5rem;

  transition: color 0.25s ease;
}

button.feature-item p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
}

button.feature-item.is-active {
  background: linear-gradient(135deg, #2f2f2f 0%, #31313181 100%);
  border-color: #d9c9a865;
  box-shadow: 0 8px 28px rgba(209, 170, 103, 0.2);
}

body.light_theme button.feature-item.is-active {

  background: linear-gradient(135deg, #faf7f2 0%, #f5efe6 100%);
  border-color: #d9c9a8;
}

button.feature-item.is-active h3 {
  color: #d1aa67;
}

button.feature-item.is-active p {
  color: #d9d9d9;
}

body.light_theme button.feature-item.is-active p {
  color: #000;
}

.features-hub-center {
  min-height: 400px;
  padding: 1rem 0 2rem;
}

/* Hub: fixed 414×414 (design); scales down as a square on narrow viewports */
.center-image-wrapper {
  position: relative;
  z-index: 0;
  box-sizing: border-box;
  width: 414px;
  max-width: 100%;
  aspect-ratio: 1;
  height: auto;
  margin: 0 auto;
  overflow: visible;
  isolation: isolate;
  flex-shrink: 0;
}

/* Static grey ring (under phone) — same viewBox as arc so tracks align */
.feature-hub-ring-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: visible;
  pointer-events: none;
  display: block;
  shape-rendering: geometricPrecision;
}

/* Phone stays inner; accent/grey rings sit on the outer track (see SVG r in index.js) */
.center-image-wrapper .center-image {
  position: relative;
  z-index: 2;
  width: 89%;
  max-width: 400px;
  height: auto;
  margin: 22px auto 0;
  display: block;
  pointer-events: none;
  object-fit: contain;
}

/* Accent arc on outer ring — above grey track, below connectors */
.feature-hub-arc-spinner {
  position: absolute;
  inset: 0;
  z-index: 3;
  pointer-events: none;
  transform-origin: 50% 50%;
  will-change: transform;
}

.feature-hub-arc-spinner>svg {
  width: 100%;
  height: 100%;
  display: block;
  overflow: visible;
  shape-rendering: geometricPrecision;
}

.feature-connector-hit {
  position: absolute;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  z-index: 4;
  line-height: 0;
  border-radius: 8px;
  transition: filter 0.25s ease, opacity 0.25s ease;
}

.feature-connector-hit.is-active {
  filter: drop-shadow(0 0 6px rgba(209, 170, 103, 0.45));
}

.feature-connector-hit:focus-visible {
  outline: 2px solid #d1aa67;
  outline-offset: 4px;
}

.feature-connector-hit svg {
  display: block;
  max-width: min(176px, 28vw);
  height: auto;
}

/* Wrapper: original SVG geometry untouched; badge sits on hub node (circle center) */
.feature-connector-inner {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: min(176px, 28vw);
  vertical-align: top;
}

.feature-connector-inner .feature-connector-lines {
  display: block;
  width: 100%;
  height: auto;
  overflow: visible;
}

/* Show endpoint circles (black disc + white ring) */
.feature-connector-inner .feature-connector-lines circle {
  opacity: 1;
}

.feature-connector-badge {
  position: absolute;
  display: block;
  width: 43px;
  height: 43px;
  object-fit: contain;
  pointer-events: none;
  border-radius: 50%;
  transition: box-shadow 0.2s ease, outline 0.2s ease, opacity 0.2s ease;
}

/* Hub centers match original circle centers in 176×100 viewBox */
.feature-connector-inner--tl .feature-connector-badge {
  /* left: calc((166 / 176) * 100% - 21.5px); */
  top: 0px;
}

.feature-connector-inner--tr .feature-connector-badge {
  right: calc((10 / 176) * 100% - 12.5px);
  top: 0px;
}

.feature-connector-inner--bl .feature-connector-badge {
  /* left: calc((166 / 176) * 100% - 21.5px); */
  top: 58px;
}

.feature-connector-inner--br .feature-connector-badge {
  right: calc((10 / 176) * 100% - 12.5px);
  top: 58px;
}

.feature-connector-hit:not(.is-active) .feature-connector-badge {
  opacity: 0.92;
}

.feature-connector-hit.is-active .feature-connector-badge {
  opacity: 1;
  outline: 2px solid #d1aa67;
  outline-offset: 2px;
  box-shadow: 0 0 12px rgba(209, 170, 103, 0.45);
}

.feature-connector-hit svg path {
  stroke: #6f6f6f;
}

.top-left-pos {
  left: -75px;
  top: 0%;
  transform: translateX(-8%);
}

.bottom-left-pos {
  left: -57px;
  bottom: 0%;
  transform: translateX(-8%);
}

.top-right-pos {
  right: -74px;
  top: 0%;
  transform: translateX(8%);
}

.bottom-right-pos {
  right: -58px;
  bottom: 0%;
  transform: translateX(8%);
}

@media screen and (max-width:1440px) {

  .hero_section.herobanner2 {
    height: 100%;
    min-height: 100%;
    padding-top: 20px;
    padding-bottom: 15px;
  }

  .top-left-pos {
    left: -102px;
    top: 0%;
  }

  .bottom-left-pos {
    left: -88px;
  }

  .bottom-right-pos {
    right: -88px;
  }

  .top-right-pos {
    right: -101px;
    top: 0%;
  }

  .hero_section.herobanner2 .slick-track {
    gap: 20px;
  }

  .banner_add_slide {
    margin: 60px 0px 40px;
  }

  .rounded_effect_bottom {
    bottom: 190px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s {
    margin-top: 80px;
  }

}

@media screen and (max-width:1200px) {

  .trading_img {
    width: 110px;
  }

  .center-image-wrapper .center-image {
    margin: 15px auto 0;
  }


  .top-right-pos {
    right: -106px;
  }

  .top-left-pos {
    left: -106px;
  }

  #popup-box.popup-box.homepop_box {
    width: 600px;
    margin: 0 auto;
  }

  .newhome_maximizeprofit_s::after {
    background-size: 400px;
    top: -15%;
  }

  .bottom-left-pos {
    left: -82px;
  }

  .bottom-right-pos {
    right: -82px;
  }

  .how_get_account_ot ul li p {
    font-size: 18px;
  }

  .trending_crypto .landing_pair_sub {
    font-size: 12px;
  }

  .trending_crypto .landing_pair_symbol {
    font-size: 15px;
  }

  .trending_crypto .landing_pair_price {
    font-size: 14px;
  }


  .trending_crypto .landing_pair_chg {
    font-size: 14px;
  }

  .scan_app_bl .scan_content a.btn {
    font-size: 16px;
    margin-top: 30px;
  }

  button.feature-item {
    padding: 15px;
    margin-bottom: 18px;
  }

  button.feature-item h3 {
    font-size: 16px;
  }

}

@media screen and (max-width:991px) {

  .banner_img {
    width: 50%;
  }

  .features-hub.features-card {
    padding: 0rem 0rem 0rem !important;
    margin-bottom: 0px !important;
    margin-top: 50px;
  }

  .scan_app_bl .scan_content a.btn {
    font-size: 13px;
  }

  .trade_platform_section {
    padding: 35px 0px 40px;
  }

  .trade_platform_section ul.trade_platform_cards_grid {
    margin-top: 20px;
    gap: 20px;
  }

  .trade_platform_section ul.trade_platform_cards_grid li p,
  .trade_platform_section .trade_platform_slide_card p {
    font-size: 15px;
    margin: 12px 0px 0px;
  }

  .trade_platform_section ul.trade_platform_cards_grid li .platform_vector,
  .trade_platform_section .trade_platform_slide_card .platform_vector {
    min-height: 180px;
  }

  .latest_resources {
    padding: 40px 0px;
  }

  .center-image-wrapper .center-image {
    margin: 12px auto 0;
  }

  .herobanner2 .banner_cnt h3 {
    font-size: 30px;
  }

  .herobanner2 .banner_cnt h1 {
    font-size: 24px;
  }

  .newhome_maximizeprofit_s .trusted_partner {
    padding: 60px 0px;
  }


}


@media screen and (max-width:767px) {

  .vector_currency img {
    width: 20px;
    opacity: 0.7;
  }

  .trending_crypto .landing_pair_symbol {
    font-size: 13px;
  }

  .banner_img {
    width: 300px !important;
  }

  body .newhome_maximizeprofit_s .row.cta_register_s {
    margin-top: 15px;
  }

  .services_block p {
    line-height: 20px;
    padding-top: 5px;
  }

  .herobanner2 .banner_cnt h1 {
    font-size: 18px;
  }

  .herobanner2 .banner_cnt h3 {
    font-size: 22px;
  }

  .how_get_account_ot ul li p {
    font-size: 15px;
  }

  .herobanner2 .scan_block {
    margin: -20px auto;
  }

  .rounded_effect_bottom {
    display: none;
  }

  .banner_add_slide .heighlightcnt img {
    height: 100%;
  }

  .hero_section.herobanner2 {
    padding-bottom: 0px;
  }

  .trading_img {
    right: inherit;
    text-align: center;
    left: inherit;
    margin: 0 auto;
    position: relative;
    top: 0px;
  }

  .services_block {
    text-align: center;
    align-items: center;
  }

  .how_get_account_ot .row .col-sm-4 {
    width: 100%;
  }

  .how_get_account_ot .row .col-sm-8 {
    width: 100%;
  }

  .services_block h4 {
    font-size: 18px;
    margin-top: 24px;
  }

  .newhome_maximizeprofit_s .profit_cost_cnt {
    text-align: center;
  }

  .newhome_maximizeprofit_s .row .col-sm-4 {
    width: 100%;
  }

  .newhome_maximizeprofit_s .row .col-sm-8 {
    width: 100%;
  }

  .newhome_maximizeprofit_s button.learnbtn {
    margin: 0 auto;
  }

  .newhome_maximizeprofit_s .trade_btn button {
    margin: 0 auto;
  }

  .how_get_account_ot .row .col-sm-6 {
    width: 100%;
  }

  .main_marker_summary .row.align-items-center .col-sm-8 {
    width: 100%;
  }

  .newhome_maximizeprofit_s .trusted_partner {
    padding: 30px 0px 10px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {
    padding-top: 0px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s {
    margin-top: 30px;
  }

  .newhome_maximizeprofit_s {
    padding-top: 15px;
  }

  .newhome_maximizeprofit_s::after {
    background-size: 300px;
    opacity: 0.5;
  }

  .services_block {
    min-height: 100%;
  }

  .newhome_maximizeprofit_s .cta_vector {
    padding-top: 24px;
  }

  .how_get_account_ot.trade_app__app {
    padding-top: 15px;
  }

  .trending_crypto .landing_pair_price {
    font-size: 13px;
  }

  .trending_crypto .landing_pair_chg {
    font-size: 12px;
  }


}

@media screen and (max-width:767px) {

  #popup-box.popup-box.homepop_box {
    width: 70%;
  }

  .trade_platform_section ul.trade_platform_cards_grid li .platform_vector,
  .trade_platform_section .trade_platform_slide_card .platform_vector {
    min-height: 100px;
  }

  .vector_currency img {
    width: 20px;
    opacity: 0.7;
  }

  .services_block p {
    line-height: 20px;
    padding-top: 5px;
  }

  .herobanner2 .banner_cnt h1 {
    font-size: 18px;
  }



  .herobanner2 .banner_cnt h3 {
    font-size: 22px;
  }

  .how_get_account_ot ul li p {
    font-size: 15px;
  }

  .herobanner2 .scan_block {
    margin: -20px auto;
  }

  .rounded_effect_bottom {
    display: none;
  }

  .banner_add_slide .heighlightcnt img {
    height: 100%;
  }

  .hero_section.herobanner2 {
    padding-bottom: 0px;
  }

  .trading_img {
    right: inherit;
    text-align: center;
    left: inherit;
    margin: 0 auto;
    position: relative;
    top: 0px;
  }

  .services_block {
    text-align: center;
    align-items: center;
  }

  .how_get_account_ot .row .col-sm-4 {
    width: 100%;
  }

  .how_get_account_ot .row .col-sm-8 {
    width: 100%;
  }

  .services_block h4 {
    font-size: 18px;
    margin-top: 24px;
  }

  .newhome_maximizeprofit_s .profit_cost_cnt {
    text-align: center;
  }

  .newhome_maximizeprofit_s .row .col-sm-4 {
    width: 100%;
  }

  .newhome_maximizeprofit_s .row .col-sm-8 {
    width: 100%;
  }

  .newhome_maximizeprofit_s button.learnbtn {
    margin: 0 auto;
  }

  .newhome_maximizeprofit_s .trade_btn button {
    margin: 0 auto;
  }

  .how_get_account_ot .row .col-sm-6 {
    width: 100%;
  }

  .main_marker_summary .row.align-items-center .col-sm-8 {
    width: 100%;
  }

  .newhome_maximizeprofit_s .trusted_partner {
    padding: 30px 0px 10px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {
    padding-top: 0px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s {
    margin-top: 30px;
  }

  .newhome_maximizeprofit_s {
    padding-top: 15px;
  }

  .newhome_maximizeprofit_s::after {
    background-size: 300px;
    opacity: 0.5;
  }

  .services_block {
    min-height: 100%;
  }

  .newhome_maximizeprofit_s .cta_vector {
    padding-top: 24px;
  }

  .how_get_account_ot.trade_app__app {
    padding-top: 15px;
  }


}

@media (max-width: 991.98px) {
  .features-hub-center {
    min-height: 320px;
  }

  .feature-connector-hit {
    display: none;
  }

  .top-left-pos,
  .bottom-left-pos,
  .top-right-pos,
  .bottom-right-pos {
    transform: none;
  }
}

/* —— trade_platform_section: desktop = grid <ul>; mobile (≤991px) = react-slick —— */
.trade_platform_slider_wrap {
  display: none;
}

.trade_platform_section .trade_platform_slide_card {
  width: 100%;
  border: 1px solid #ffffff14;
  background-color: #ffffff15;
  padding: 24px;
  border-radius: 12px;
  transition: all 0.5s;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.trade_platform_section .trade_platform_slide_card:hover {
  background-color: #d1aa6740;
  border: 1px solid #d1aa67;
  box-shadow: 0 0 30px #d1aa67;
}

.trade_platform_section .trade_platform_slide_card .platform_vector {
  display: flex;
  justify-content: flex-end;
}

.trade_platform_section .trade_platform_slide_card .platform_vector img {
  max-width: 160px;
}

.trade_platform_section .trade_platform_slide_card h3 {
  font-size: 20px;
}

.trade_platform_section .trade_platform_slide_card p {
  font-size: 16px;
  color: #ffffff70;
  margin: 20px 0 0;
}

@media screen and (max-width:580px) {

  #popup-box.popup-box.homepop_box {
    width: 85%;
  }

  .trending_crypto_tabs button {
    font-size: 13px;
  }

  .viewmorebtn a {
    font-size: 14px;
  }

}

@media screen and (max-width: 991.98px) {
  .trade_platform_section ul.trade_platform_cards_grid {
    display: none !important;
  }

  .trade_platform_slider_wrap {
    display: block;
    margin-top: 20px;
    padding-bottom: 4px;
  }

  .trade_platform_slider_wrap .slick-list {
    margin: 0 -8px;
  }

  .trade_platform_slider_wrap .slick-slide>div {
    padding: 0 8px;
  }

  .trade_platform_section .trade_platform_slide_card p {
    font-size: 15px;
    margin: 12px 0 0;
  }
}

.trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots,
.trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots {
  position: relative;
  bottom: auto;
  margin-top: 16px;
  display: flex !important;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li,
.trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li {
  height: auto;
  margin: 0;
  width: auto;
}

.trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li button,
.trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li button {
  width: auto;
  height: auto;
  padding: 0;
}

.trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li button:before,
.trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li button:before {
  font-size: 0;
  width: 8px;
  height: 8px;
  border-radius: 50px;
  background: #ffffff50;
  opacity: 1;
  left: 0;
  top: 0;
  content: "";
}

.trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li.slick-active button:before,
.trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li.slick-active button:before {
  width: 12px;
  background: #d1aa67;
}

body.light_theme .trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li button:before,
body.light_theme .trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li button:before {
  background: #bfc1c9b0;
}

body.light_theme .trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li.slick-active button:before,
body.light_theme .trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li.slick-active button:before {
  background: #d1aa67;
}

/* latest_resources: desktop = 3 columns; mobile / tablet (≤991px) = tab strip + one card (like trending_crypto) */
.latest_resources_tabs {
  display: none;
}

@media screen and (max-width: 991.98px) {
  .latest_resources_tabs {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    flex-wrap: nowrap;
    gap: 24px;
    width: 100%;
    margin-top: 16px;
    margin-bottom: 8px;
    padding: 0 4px;
  }

  .cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li button,
  .cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li button {
    width: 15px;
    height: 5px;
  }

  .cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li.slick-active button:before,
  .cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li.slick-active button:before {
    width: 16px;
  }

  .cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots,
  .cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots {
    margin: 12px 0px 0px;
  }

  .latest_resources_tabs button {
    flex: inherit;
    min-width: 0;
    margin: 0;
    padding: 8px 4px;
    font-size: 13px;
    position: relative;
    font-weight: 500;
    line-height: 1.2;
    border: none;
    background: none;
    color: #5c5c5c;
    cursor: pointer;
    transition: color 0.2s ease, opacity 0.2s ease;
  }

  .latest_resources_tabs button::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 18px;
    height: 2.5px;
    background: #2c2c2c;
    margin: 0 auto;
    border-radius: 20px;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  .latest_resources_tabs button.active::before {
    opacity: 1;
  }

  .latest_resources_tabs button.active {
    color: #000000;
  }

  .latest_resources_cards_row>.latest_resources_col {
    display: none !important;
  }

  .latest_resources_cards_row>.latest_resources_col.active {
    display: block !important;
    flex: 0 0 100%;
    max-width: 100%;
  }

  .latest_resources_cards_row .resources_news {
    min-height: 0;
  }
}

body.light_theme .latest_resources_tabs button {
  color: #84888c;
}

body.light_theme .latest_resources_tabs button.active {
  color: #0d0d0d;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/LandingPage/home.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,8DAA8D;AAChE;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,yDAA6E;EAC7E,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB;;;sBAGoB;EACpB,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kEAAkE;AACpE;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;;EAEE;;IAEE,8CAA8C;EAChD;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,yDAAyD;EAC3D;AACF;;AAEA;;EAEE;;IAEE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;;EAEE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yDAAmF;EACnF,oBAAoB;EACpB,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yDAAoF;EACpF,oBAAoB;EACpB,4BAA4B;EAC5B,gCAAgC;EAChC,cAAc;EACd,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;AAC/B;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;GAGG;;;AAGH;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yDAA0E;EAC1E,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,yDAA6E;EAC7E,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yDAAmF;EACnF,oBAAoB;EACpB,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yDAAoF;EACpF,oBAAoB;EACpB,4BAA4B;EAC5B,gCAAgC;EAChC,cAAc;EACd,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;AAC/B;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yDAA0E;EAC1E,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;;;;;AAMA;;EAEE;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;;AAGF;;AAEA;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;;AAGF;;;AAGA,yEAAyE;AACzE;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;;IAEb,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yEAAyE;EAC3E;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;AAEF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;GAGG;;AAEH;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;;EAEE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,+CAA+C;AACjD;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iFAAiF;EACjF,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;EAElB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+DAA+D;EAC/D,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;;EAEE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,6EAA6E;AAC7E;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mCAAmC;AACrC;;AAEA,wFAAwF;AACxF;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,YAAY;AACd;;AAEA,qFAAqF;AACrF;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sEAAsE;AACxE;;AAEA,iEAAiE;AACjE;EACE,6CAA6C;EAC7C,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,QAAQ;AACV;;AAEA;EACE,6CAA6C;EAC7C,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,OAAO;EACP,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,OAAO;EACT;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,OAAO;EACT;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,kCAAkC;IAClC,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;;IAEE,eAAe;IACf,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;;AAGF;;;AAGA;;EAEE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;AAGF;;AAEA;;EAEE;IACE,UAAU;EACZ;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;;;EAIA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;;AAGF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,eAAe;EACjB;AACF;;AAEA,qFAAqF;AACrF;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,kHAAkH;AAClH;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,8CAA8C;EAChD;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".herobanner2 .scan_block {\n  background-color: #0C0900;\n  margin: -10px auto;\n}\n\n.banner_add_slide {\n  margin: 80px 0px 60px;\n  position: relative;\n  z-index: 6666;\n}\n\n.banner_add_slide .heighlightcnt img {\n  border-radius: 13px;\n}\n\n.banner_add_slide .slick-dots li button:before {\n  font-size: 0px;\n  background-color: #FFFBFB;\n  left: 0;\n  width: 10px;\n  border-radius: 50px;\n  height: 10px;\n}\n\nbody .banner_add_slide .slick-dots li.slick-active button:before {\n  width: 24px;\n  background-color: #F3BB2B;\n}\n\n#popup-box.popup-box.homepop_box {\n  width: 700px;\n  animation: lp-pop-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n@keyframes lp-pop-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.98);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  #popup-box.popup-box.homepop_box {\n    animation: none !important;\n  }\n}\n\nbody .banner_add_slide .slick-dots li button {\n  width: auto;\n  height: auto;\n}\n\nbody .banner_add_slide .slick-dots li {\n  width: auto;\n  height: auto;\n}\n\nbody .banner_add_slide .slick-dots li.slick-active {\n  width: 24px;\n}\n\n\n.herobanner2 {\n  background-image: url('../../../../public/images/new_img/hero_bannerbg2.svg');\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n/* —— Hero banner image (hero_section_main): glow + float + reveal —— */\n.hero_section_main .banner_img {\n  position: relative;\n  z-index: 1;\n}\n\n.hero_section_main .banner_img_main {\n  position: relative;\n  transform-style: preserve-3d;\n}\n\n.hero_section_main .banner_img_main::before {\n  content: \"\";\n  position: absolute;\n  inset: -10% -6% -6% -6%;\n  z-index: 0;\n  pointer-events: none;\n  background: radial-gradient(ellipse 70% 60% at 50% 58%,\n      rgba(209, 170, 103, 0.28) 0%,\n      rgba(209, 170, 103, 0.06) 45%,\n      transparent 72%);\n  filter: blur(2px);\n  animation: bannerHeroGlow 5s ease-in-out infinite;\n}\n\n.hero_section_main .banner_img_motion {\n  position: relative;\n  z-index: 1;\n  transform-origin: 50% 60%;\n  animation: bannerHeroFloat 7s ease-in-out infinite;\n}\n\n.hero_section_main .banner_img_motion img {\n  display: block;\n  width: 100%;\n  height: auto;\n  animation: bannerHeroReveal 1s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes bannerHeroReveal {\n  from {\n    opacity: 0;\n    filter: blur(6px);\n  }\n\n  to {\n    opacity: 1;\n    filter: blur(0);\n  }\n}\n\n@keyframes bannerHeroFloat {\n\n  0%,\n  100% {\n    transform: translateY(0) rotate(0deg) scale(1);\n  }\n\n  40% {\n    transform: translateY(-14px) rotate(0.75deg) scale(1.012);\n  }\n\n  65% {\n    transform: translateY(-6px) rotate(-0.45deg) scale(1.004);\n  }\n}\n\n@keyframes bannerHeroGlow {\n\n  0%,\n  100% {\n    opacity: 0.75;\n    transform: scale(0.96);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.04);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .hero_section_main .banner_img_main::before,\n  .hero_section_main .banner_img_motion {\n    animation: none !important;\n  }\n\n  .hero_section_main .banner_img_motion img {\n    animation: none !important;\n    opacity: 1;\n    filter: none;\n  }\n}\n\n.how_get_account_ot ul li p {\n  font-size: 22px;\n}\n\n.herobanner2 .banner_cnt {\n  padding-top: 100px;\n}\n\n.herobanner2 .banner_cnt h3 {\n  font-size: 35px;\n  font-weight: 400;\n  text-transform: capitalize;\n}\n\n.herobanner2 .banner_cnt h1 span {\n  color: #f3bb2b;\n}\n\n.uptates_sm.market_update_outer h2 span {\n  color: #f3bb2b;\n}\n\n.uptates_sm .trade_btn button {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.services_block h4 {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.services_block p {\n  line-height: 24px;\n}\n\n.started_trading_s {\n  position: relative;\n}\n\n.started_trading_s::before {\n  position: absolute;\n  right: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/get_standerdbg_after.svg');\n  background-size: 28%;\n  background-repeat: no-repeat;\n  background-position: right;\n  top: -620px;\n  z-index: 333;\n  left: inherit;\n  width: 100%;\n}\n\n.started_trading_s .how_get_account_ot .trade_btn button {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.started_trading_s .trading_platform_section {\n  background-color: transparent;\n  position: relative;\n  z-index: 666;\n}\n\n.started_trading_s .trading_platform_section h2 span {\n  color: #f3bb2b;\n  display: inline;\n  padding-right: 10px;\n}\n\n.started_trading_s .services_block:hover {\n  background-color: transparent;\n}\n\n.started_trading_s::after {\n  position: absolute;\n  left: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/get_standerdbg_before.svg');\n  background-size: 40%;\n  background-repeat: no-repeat;\n  background-position: left bottom;\n  bottom: -300px;\n  z-index: 333;\n  right: inherit;\n  width: 100%;\n  opacity: 0.6;\n}\n\nbody.light_theme .rounded_effect_bottom {\n  opacity: 0.2;\n}\n\n.started_trading_s .how_get_account_ot {\n  z-index: 666;\n  position: relative;\n  background-image: none !important;\n  background-color: transparent;\n}\n\n\n.how_get_account_ot h2 span {\n  color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s h2 {\n  letter-spacing: -1px;\n}\n\n.newhome_maximizeprofit_s {\n  z-index: 666;\n  background-color: transparent;\n}\n\n.newhome_maximizeprofit_s h2 span {\n  color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s .right_costs_rg ul li {\n  color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s .cta_register_s ul.social_media {\n  margin: 100px 0px 20px;\n}\n\n.newhome_maximizeprofit_s .trade_btn button {\n  display: flex;\n  gap: 18px;\n  align-items: center;\n  border: 1px solid #f3bb2b;\n  color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s ul.social_media a {\n  background-color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s button.learnbtn a {\n  background-color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s .profit_cost_cnt {\n  padding: 0px 0px 0px;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #111;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #333;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* * {\n  scrollbar-width: thin;\n  scrollbar-color: #333 #111;\n} */\n\n\n.newhome_maximizeprofit_s::after {\n  position: absolute;\n  right: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/ctabg_after.svg');\n  background-size: 600px;\n  background-repeat: no-repeat;\n  background-position: right top;\n  top: -27%;\n  z-index: 333;\n  left: inherit;\n  width: 100%;\n}\n\n.newhome_maximizeprofit_s .container {\n  position: relative;\n  z-index: 666;\n}\n\n.row.cta_register_s {\n  align-items: center;\n}\n\n.newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {\n  padding-top: 40px;\n}\n\n.newhome_maximizeprofit_s .trusted_partner {\n  padding: 100px 0px;\n}\n\n.vector_currency.one {\n  top: 0px;\n}\n\n.banner_animation_vector.rightside .vector_currency.one {\n  top: 0px;\n}\n\n\nbody.light_theme .herobanner2 .scan_block {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .join_group_s button.joinbtn {\n  color: #222222;\n}\n\nbody.light_theme .herobanner2 button.morebtn {\n  color: #222;\n}\n\nbody.light_theme .herobanner2 .scan_cnt {\n  color: #222;\n}\n\nbody.light_theme .herobanner2 .banner_cnt .scan_block p {\n  color: #222;\n}\n\nbody.light_theme .banner_add_slide .slick-dots li button:before {\n  background-color: #747474;\n}\n\n.market_update_outer .container {\n  position: relative;\n  z-index: 666;\n}\n\nbody.light_theme .how_get_account_ot.bgtransparrent_s {\n  background-color: transparent;\n}\n\nbody.light_theme .profit_costs_cta_outer.newhome_maximizeprofit_s {\n  background-color: transparent;\n}\n\nbody.light_theme .started_trading_s .how_get_account_ot {\n  background-color: transparent;\n}\n\nbody.light_theme .trading_platform_section h2 {\n  color: #0C0900;\n}\n\nbody.light_theme .services_block {\n  border: 1px solid #dddddd;\n  background-color: #f5f5f5;\n  color: #000;\n}\n\nbody.light_theme .services_block p {\n  color: #000;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item {\n  color: #141414;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item h3 button.accordion-button {\n  color: #141414;\n  border-bottom: 1px solid #a9a9a9;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item .collapse.show {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item.active h3 button.accordion-button[aria-expanded=\"true\"] {\n  background-color: #f5f5f5;\n  border-color: #f5f5f5 !important;\n}\n\nimg.light_m {\n  display: none;\n}\n\nbody.light_theme img.light_m {\n  display: flex;\n  margin: 0 auto;\n}\n\nbody.light_theme img.drak_d {\n  display: none;\n}\n\nbody.light_theme .scan_left_s img.light_m {\n  margin-left: 0px;\n  margin: inherit;\n}\n\n\n.herobanner2 .scan_block {\n  background-color: #0C0900;\n  margin: -10px auto;\n}\n\n.banner_add_slide {\n  margin: 80px 0px 60px;\n  position: relative;\n  z-index: 6666;\n}\n\n.banner_add_slide .heighlightcnt img {\n  border-radius: 13px;\n}\n\n.banner_add_slide .slick-dots li button:before {\n  font-size: 0px;\n  background-color: #FFFBFB;\n  left: 0;\n  width: 10px;\n  border-radius: 50px;\n  height: 10px;\n}\n\nbody .banner_add_slide .slick-dots li.slick-active button:before {\n  width: 24px;\n  background-color: #F3BB2B;\n}\n\nbody .banner_add_slide .slick-dots li button {\n  width: auto;\n  height: auto;\n}\n\nbody .banner_add_slide .slick-dots li {\n  width: auto;\n  height: auto;\n}\n\nbody .banner_add_slide .slick-dots li.slick-active {\n  width: 24px;\n}\n\n\n.herobanner2 {\n  background-image: url('../../../../public/images/new_img/hero_bannerbg2.svg');\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.how_get_account_ot ul li p {\n  font-size: 22px;\n}\n\n.herobanner2 .banner_cnt {\n  padding-top: 100px;\n}\n\n.herobanner2 .banner_cnt h3 {\n  font-size: 40px;\n  font-weight: 400;\n  text-transform: capitalize;\n}\n\n.herobanner2 .banner_cnt h1 span {\n  color: #f3bb2b;\n}\n\n.uptates_sm.market_update_outer h2 span {\n  color: #f3bb2b;\n}\n\n.uptates_sm .trade_btn button {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.services_block {\n  font-family: \"Afacad\", sans-serif;\n}\n\n.services_block h4 {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.services_block p {\n  line-height: 24px;\n}\n\n\n.started_trading_s {\n  position: relative;\n}\n\n.started_trading_s::before {\n  position: absolute;\n  right: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/get_standerdbg_after.svg');\n  background-size: 28%;\n  background-repeat: no-repeat;\n  background-position: right;\n  top: -620px;\n  z-index: 333;\n  left: inherit;\n  width: 100%;\n}\n\n.started_trading_s .how_get_account_ot .trade_btn button {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.started_trading_s .trading_platform_section {\n  background-color: transparent;\n  position: relative;\n  z-index: 666;\n}\n\n.started_trading_s .trading_platform_section h2 span {\n  color: #f3bb2b;\n  display: inline;\n  padding-right: 10px;\n}\n\n.started_trading_s .services_block:hover {\n  background-color: transparent;\n}\n\n.started_trading_s::after {\n  position: absolute;\n  left: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/get_standerdbg_before.svg');\n  background-size: 40%;\n  background-repeat: no-repeat;\n  background-position: left bottom;\n  bottom: -300px;\n  z-index: 333;\n  right: inherit;\n  width: 100%;\n  opacity: 0.6;\n}\n\nbody.light_theme .rounded_effect_bottom {\n  opacity: 0.2;\n}\n\n.started_trading_s .how_get_account_ot {\n  z-index: 666;\n  position: relative;\n  background-image: none !important;\n  background-color: transparent;\n}\n\n\n.how_get_account_ot h2 span {\n  color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s h2 {\n  letter-spacing: -1px;\n}\n\n.newhome_maximizeprofit_s {\n  z-index: 666;\n  background-color: transparent;\n}\n\n.newhome_maximizeprofit_s h2 span {\n  color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s .right_costs_rg ul li {\n  color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s .cta_register_s ul.social_media {\n  margin: 100px 0px 20px;\n}\n\n.newhome_maximizeprofit_s .trade_btn button {\n  display: flex;\n  gap: 18px;\n  align-items: center;\n  border: 1px solid #f3bb2b;\n  color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s ul.social_media a {\n  background-color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s button.learnbtn a {\n  background-color: #f3bb2b;\n}\n\n.newhome_maximizeprofit_s .profit_cost_cnt {\n  padding: 0px 0px 0px;\n}\n\n\n.newhome_maximizeprofit_s::after {\n  position: absolute;\n  right: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/ctabg_after.svg');\n  background-size: 600px;\n  background-repeat: no-repeat;\n  background-position: right top;\n  top: -27%;\n  z-index: 333;\n  left: inherit;\n  width: 100%;\n}\n\n.newhome_maximizeprofit_s .container {\n  position: relative;\n  z-index: 666;\n}\n\n.row.cta_register_s {\n  align-items: center;\n}\n\n.newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {\n  padding-top: 40px;\n}\n\n.newhome_maximizeprofit_s .trusted_partner {\n  padding: 100px 0px;\n}\n\n.vector_currency.one {\n  top: 0px;\n}\n\n.banner_animation_vector.rightside .vector_currency.one {\n  top: 0px;\n}\n\n\nbody.light_theme .herobanner2 .scan_block {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .join_group_s button.joinbtn {\n  color: #222222;\n}\n\nbody.light_theme .herobanner2 button.morebtn {\n  color: #222;\n}\n\nbody.light_theme .herobanner2 .scan_cnt {\n  color: #222;\n}\n\nbody.light_theme .herobanner2 .banner_cnt .scan_block p {\n  color: #222;\n}\n\nbody.light_theme .banner_add_slide .slick-dots li button:before {\n  background-color: #747474;\n}\n\n.market_update_outer .container {\n  position: relative;\n  z-index: 666;\n}\n\nbody.light_theme .how_get_account_ot.bgtransparrent_s {\n  background-color: transparent;\n}\n\nbody.light_theme .profit_costs_cta_outer.newhome_maximizeprofit_s {\n  background-color: transparent;\n}\n\nbody.light_theme .started_trading_s .how_get_account_ot {\n  background-color: transparent;\n}\n\nbody.light_theme .trading_platform_section h2 {\n  color: #0C0900;\n}\n\nbody.light_theme .services_block {\n  border: 1px solid #dddddd;\n  background-color: #f5f5f5;\n  color: #000;\n}\n\nbody.light_theme .services_block p {\n  color: #000;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item {\n  color: #141414;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item h3 button.accordion-button {\n  color: #141414;\n  border-bottom: 1px solid #a9a9a9;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item .collapse.show {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item.active h3 button.accordion-button[aria-expanded=\"true\"] {\n  background-color: #f5f5f5;\n  border-color: #f5f5f5 !important;\n}\n\nimg.light_m {\n  display: none;\n}\n\nbody.light_theme img.light_m {\n  display: flex;\n  margin: 0 auto;\n}\n\nbody.light_theme img.drak_d {\n  display: none;\n}\n\nbody.light_theme .scan_left_s img.light_m {\n  margin-left: 0px;\n  margin: inherit;\n}\n\n\n\n\n\n@media screen and (max-width:1440px) {\n\n  .hero_section.herobanner2 {\n    height: 100%;\n    min-height: 100%;\n    padding-top: 20px;\n    padding-bottom: 15px;\n  }\n\n  .banner_animation_vector {\n    top: 90px;\n  }\n\n  .hero_section.herobanner2 .slick-track {\n    gap: 20px;\n  }\n\n  .banner_add_slide {\n    margin: 60px 0px 40px;\n  }\n\n  .rounded_effect_bottom {\n    bottom: 190px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s {\n    margin-top: 80px;\n  }\n\n}\n\n@media screen and (max-width:1200px) {\n\n  .trading_img {\n    width: 110px;\n  }\n\n  .newhome_maximizeprofit_s::after {\n    background-size: 400px;\n    top: -15%;\n  }\n\n  .how_get_account_ot ul li p {\n    font-size: 18px;\n  }\n\n\n}\n\n@media screen and (max-width:991px) {\n\n  .banner_img {\n    width: 50%;\n  }\n\n  .herobanner2 .banner_cnt h3 {\n    font-size: 30px;\n  }\n\n  .herobanner2 .banner_cnt h1 {\n    font-size: 24px;\n  }\n\n  .newhome_maximizeprofit_s .trusted_partner {\n    padding: 60px 0px;\n  }\n\n\n}\n\n\n/* Landing — Trending cards: ticker + subtext + USD price + % (stacked) */\n.trending_crypto .td_first.landing_pair_row {\n  align-items: center;\n  gap: 12px;\n}\n\n.trending_crypto .landing_pair_names {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  text-align: left;\n}\n\n.trending_crypto .landing_pair_symbol {\n  font-size: 16px;\n  font-weight: 600;\n  color: #eaecef;\n  line-height: 1.2;\n}\n\n.trending_crypto .landing_pair_sub {\n  font-size: 13px;\n  font-weight: 300;\n  padding-top: 3px;\n  color: #848e9c;\n  line-height: 1.2;\n}\n\n.trending_crypto .landing_pair_price_stack {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.trending_crypto .landing_pair_price {\n  font-size: 16px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\n.trending_crypto .landing_pair_chg {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n.trending_crypto .landing_pair_chg.green {\n  color: #5eba89;\n}\n\n.trending_crypto .landing_pair_chg.red {\n  color: #F65454;\n}\n\n/* Mobile / tablet: tab strip (style.css hides non-.active panels ≤991px) */\n.trending_crypto_tabs {\n  display: none;\n}\n\n@media screen and (max-width: 991.98px) {\n  .trending_crypto_tabs {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    flex-wrap: nowrap;\n    gap: 20px;\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 8px;\n  }\n\n  .trending_crypto_tabs button {\n    flex: inherit;\n    ;\n    min-width: 0;\n    margin: 0;\n    padding: 8px 0px;\n    font-size: 15px;\n    position: relative;\n    font-weight: 400;\n    line-height: 1.2;\n    /* border-radius: 50px; */\n    border: none;\n    background: none;\n    color: #8f8f8f;\n    cursor: pointer;\n    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n  }\n\n  body.light_theme .trending_crypto_tabs button {\n    color: #444;\n  }\n\n  .trending_crypto_tabs button:before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 18px;\n    height: 2.5px;\n    right: 0px;\n    background: #ebebeb;\n    margin: 0 auto;\n    border-radius: 20px;\n    opacity: 0;\n  }\n\n  body.light_theme .trending_crypto_tabs button:before {\n    background: #000000;\n  }\n\n  .trending_crypto_tabs button.active:before {\n    opacity: 1;\n  }\n\n  .trending_crypto_tabs button.active {\n    color: #fff;\n  }\n\n  .viewmorebtn a {\n    font-size: 16px;\n  }\n\n  .banner_bottom_vector {\n    display: none;\n  }\n\n}\n\nbody.light_theme .trending_crypto_tabs button {\n  color: #84888c;\n}\n\nbody.light_theme .trending_crypto_tabs button.active {\n  color: #000000;\n}\n\n/* .trending_crypto .hot_spot_outer.hot_spot_outer--highlight {\n  border: 2px solid #3b82f6;\n  box-shadow: 0 8px 28px rgba(59, 130, 246, 0.15);\n} */\n\nbody.light_theme .trending_crypto .landing_pair_symbol,\nbody.light_theme .trending_crypto .landing_pair_price {\n  color: #0D0D0D;\n}\n\nbody.light_theme .trending_crypto .landing_pair_sub {\n  color: #6b7280;\n}\n\n/* Promo banner strip — react-slick (gold pill active dot, grey dots) */\n.cardbnr_crypto_section {\n  padding: 20px 0 24px;\n  background: #000;\n}\n\nbody.light_theme .cardbnr_crypto_section {\n  background: #f6f6f6;\n}\n\n.cardbnr_crypto_slide .cardbnr_crypto_slick.slick-slider {\n  margin-bottom: 0;\n}\n\n/* ~12px gap between cards (screenshot-style tight strip) */\n.cardbnr_crypto_slide .slick-list {\n  margin: 0 -6px;\n}\n\n.cardbnr_crypto_slide .slick-slide {\n  height: auto;\n}\n\n.cardbnr_crypto_slide .slick-slide>div {\n  padding: 0 6px;\n}\n\n.cardbnr_slide_inner {\n  border-radius: 16px;\n  overflow: hidden;\n  line-height: 0;\n}\n\n.cardbnr_slide_inner img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: cover;\n}\n\n/* Dots: always visible (override global slick / theme opacity) */\n.cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots,\n.cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots {\n  position: relative;\n  bottom: auto;\n  left: auto;\n  right: auto;\n  margin: 24px 0 0;\n  padding: 8px 0 0;\n  width: 100%;\n  display: flex !important;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 0;\n  list-style: none;\n  z-index: 2;\n}\n\n.cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li,\n.cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li {\n  width: auto;\n  height: auto;\n  margin: 0 4px;\n  opacity: 1 !important;\n}\n\n.cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li button,\n.cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li button {\n  width: 30px;\n  height: 12px;\n  padding: 0;\n  position: relative;\n  opacity: 1 !important;\n}\n\n.cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li button:before,\n.cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li button:before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #a8a9b0;\n  opacity: 1 !important;\n  font-size: 0;\n  line-height: 0;\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12);\n}\n\n.cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li.slick-active button:before,\n.cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li.slick-active button:before {\n  width: 26px;\n  height: 8px;\n  border-radius: 999px;\n  background: #D1AA67;\n}\n\nbody.light_theme .cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li button:before,\nbody.light_theme .cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li button:before {\n  background: #bfc1c9b0;\n}\n\nbody.light_theme .cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li.slick-active button:before,\nbody.light_theme .cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li.slick-active button:before {\n  background: #D1AA67;\n}\n\n/* —— Trade & Earn: interactive hub (rotating arc + active cards) —— */\n.trade_earn_section {\n  max-height: none !important;\n  padding-bottom: 4rem !important;\n}\n\n.features-hub.features-card {\n  background-color: #171a20;\n  border-radius: 2rem;\n  padding: 2rem 1rem 3rem;\n  margin-top: 40px;\n}\n\nbody.light_theme .features-hub.features-card {\n  background-color: #fff;\n}\n\nbutton.feature-item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  min-height: 124px;\n  background: #ffffff14;\n  border: 1px solid #cecfd021;\n  border-radius: 16px;\n  padding: 1.25rem 1.35rem;\n  text-align: center;\n  margin-bottom: 32px;\n  cursor: pointer;\n  transition: background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;\n  color: #d9d9d9;\n}\n\nbody.light_theme button.feature-item {\n  background: #fff;\n  border: 1px solid #CECFD0;\n  color: #878787;\n}\n\nbutton.feature-item h3 {\n  font-size: 20px;\n  font-weight: 500;\n  margin: 0 0 0.5rem;\n\n  transition: color 0.25s ease;\n}\n\nbutton.feature-item p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  font-weight: 400;\n}\n\nbutton.feature-item.is-active {\n  background: linear-gradient(135deg, #2f2f2f 0%, #31313181 100%);\n  border-color: #d9c9a865;\n  box-shadow: 0 8px 28px rgba(209, 170, 103, 0.2);\n}\n\nbody.light_theme button.feature-item.is-active {\n\n  background: linear-gradient(135deg, #faf7f2 0%, #f5efe6 100%);\n  border-color: #d9c9a8;\n}\n\nbutton.feature-item.is-active h3 {\n  color: #d1aa67;\n}\n\nbutton.feature-item.is-active p {\n  color: #d9d9d9;\n}\n\nbody.light_theme button.feature-item.is-active p {\n  color: #000;\n}\n\n.features-hub-center {\n  min-height: 400px;\n  padding: 1rem 0 2rem;\n}\n\n/* Hub: fixed 414×414 (design); scales down as a square on narrow viewports */\n.center-image-wrapper {\n  position: relative;\n  z-index: 0;\n  box-sizing: border-box;\n  width: 414px;\n  max-width: 100%;\n  aspect-ratio: 1;\n  height: auto;\n  margin: 0 auto;\n  overflow: visible;\n  isolation: isolate;\n  flex-shrink: 0;\n}\n\n/* Static grey ring (under phone) — same viewBox as arc so tracks align */\n.feature-hub-ring-bg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  overflow: visible;\n  pointer-events: none;\n  display: block;\n  shape-rendering: geometricPrecision;\n}\n\n/* Phone stays inner; accent/grey rings sit on the outer track (see SVG r in index.js) */\n.center-image-wrapper .center-image {\n  position: relative;\n  z-index: 2;\n  width: 89%;\n  max-width: 400px;\n  height: auto;\n  margin: 22px auto 0;\n  display: block;\n  pointer-events: none;\n  object-fit: contain;\n}\n\n/* Accent arc on outer ring — above grey track, below connectors */\n.feature-hub-arc-spinner {\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n  pointer-events: none;\n  transform-origin: 50% 50%;\n  will-change: transform;\n}\n\n.feature-hub-arc-spinner>svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  overflow: visible;\n  shape-rendering: geometricPrecision;\n}\n\n.feature-connector-hit {\n  position: absolute;\n  background: transparent;\n  border: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  z-index: 4;\n  line-height: 0;\n  border-radius: 8px;\n  transition: filter 0.25s ease, opacity 0.25s ease;\n}\n\n.feature-connector-hit.is-active {\n  filter: drop-shadow(0 0 6px rgba(209, 170, 103, 0.45));\n}\n\n.feature-connector-hit:focus-visible {\n  outline: 2px solid #d1aa67;\n  outline-offset: 4px;\n}\n\n.feature-connector-hit svg {\n  display: block;\n  max-width: min(176px, 28vw);\n  height: auto;\n}\n\n/* Wrapper: original SVG geometry untouched; badge sits on hub node (circle center) */\n.feature-connector-inner {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  max-width: min(176px, 28vw);\n  vertical-align: top;\n}\n\n.feature-connector-inner .feature-connector-lines {\n  display: block;\n  width: 100%;\n  height: auto;\n  overflow: visible;\n}\n\n/* Show endpoint circles (black disc + white ring) */\n.feature-connector-inner .feature-connector-lines circle {\n  opacity: 1;\n}\n\n.feature-connector-badge {\n  position: absolute;\n  display: block;\n  width: 43px;\n  height: 43px;\n  object-fit: contain;\n  pointer-events: none;\n  border-radius: 50%;\n  transition: box-shadow 0.2s ease, outline 0.2s ease, opacity 0.2s ease;\n}\n\n/* Hub centers match original circle centers in 176×100 viewBox */\n.feature-connector-inner--tl .feature-connector-badge {\n  /* left: calc((166 / 176) * 100% - 21.5px); */\n  top: 0px;\n}\n\n.feature-connector-inner--tr .feature-connector-badge {\n  right: calc((10 / 176) * 100% - 12.5px);\n  top: 0px;\n}\n\n.feature-connector-inner--bl .feature-connector-badge {\n  /* left: calc((166 / 176) * 100% - 21.5px); */\n  top: 58px;\n}\n\n.feature-connector-inner--br .feature-connector-badge {\n  right: calc((10 / 176) * 100% - 12.5px);\n  top: 58px;\n}\n\n.feature-connector-hit:not(.is-active) .feature-connector-badge {\n  opacity: 0.92;\n}\n\n.feature-connector-hit.is-active .feature-connector-badge {\n  opacity: 1;\n  outline: 2px solid #d1aa67;\n  outline-offset: 2px;\n  box-shadow: 0 0 12px rgba(209, 170, 103, 0.45);\n}\n\n.feature-connector-hit svg path {\n  stroke: #6f6f6f;\n}\n\n.top-left-pos {\n  left: -75px;\n  top: 0%;\n  transform: translateX(-8%);\n}\n\n.bottom-left-pos {\n  left: -57px;\n  bottom: 0%;\n  transform: translateX(-8%);\n}\n\n.top-right-pos {\n  right: -74px;\n  top: 0%;\n  transform: translateX(8%);\n}\n\n.bottom-right-pos {\n  right: -58px;\n  bottom: 0%;\n  transform: translateX(8%);\n}\n\n@media screen and (max-width:1440px) {\n\n  .hero_section.herobanner2 {\n    height: 100%;\n    min-height: 100%;\n    padding-top: 20px;\n    padding-bottom: 15px;\n  }\n\n  .top-left-pos {\n    left: -102px;\n    top: 0%;\n  }\n\n  .bottom-left-pos {\n    left: -88px;\n  }\n\n  .bottom-right-pos {\n    right: -88px;\n  }\n\n  .top-right-pos {\n    right: -101px;\n    top: 0%;\n  }\n\n  .hero_section.herobanner2 .slick-track {\n    gap: 20px;\n  }\n\n  .banner_add_slide {\n    margin: 60px 0px 40px;\n  }\n\n  .rounded_effect_bottom {\n    bottom: 190px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s {\n    margin-top: 80px;\n  }\n\n}\n\n@media screen and (max-width:1200px) {\n\n  .trading_img {\n    width: 110px;\n  }\n\n  .center-image-wrapper .center-image {\n    margin: 15px auto 0;\n  }\n\n\n  .top-right-pos {\n    right: -106px;\n  }\n\n  .top-left-pos {\n    left: -106px;\n  }\n\n  #popup-box.popup-box.homepop_box {\n    width: 600px;\n    margin: 0 auto;\n  }\n\n  .newhome_maximizeprofit_s::after {\n    background-size: 400px;\n    top: -15%;\n  }\n\n  .bottom-left-pos {\n    left: -82px;\n  }\n\n  .bottom-right-pos {\n    right: -82px;\n  }\n\n  .how_get_account_ot ul li p {\n    font-size: 18px;\n  }\n\n  .trending_crypto .landing_pair_sub {\n    font-size: 12px;\n  }\n\n  .trending_crypto .landing_pair_symbol {\n    font-size: 15px;\n  }\n\n  .trending_crypto .landing_pair_price {\n    font-size: 14px;\n  }\n\n\n  .trending_crypto .landing_pair_chg {\n    font-size: 14px;\n  }\n\n  .scan_app_bl .scan_content a.btn {\n    font-size: 16px;\n    margin-top: 30px;\n  }\n\n  button.feature-item {\n    padding: 15px;\n    margin-bottom: 18px;\n  }\n\n  button.feature-item h3 {\n    font-size: 16px;\n  }\n\n}\n\n@media screen and (max-width:991px) {\n\n  .banner_img {\n    width: 50%;\n  }\n\n  .features-hub.features-card {\n    padding: 0rem 0rem 0rem !important;\n    margin-bottom: 0px !important;\n    margin-top: 50px;\n  }\n\n  .scan_app_bl .scan_content a.btn {\n    font-size: 13px;\n  }\n\n  .trade_platform_section {\n    padding: 35px 0px 40px;\n  }\n\n  .trade_platform_section ul.trade_platform_cards_grid {\n    margin-top: 20px;\n    gap: 20px;\n  }\n\n  .trade_platform_section ul.trade_platform_cards_grid li p,\n  .trade_platform_section .trade_platform_slide_card p {\n    font-size: 15px;\n    margin: 12px 0px 0px;\n  }\n\n  .trade_platform_section ul.trade_platform_cards_grid li .platform_vector,\n  .trade_platform_section .trade_platform_slide_card .platform_vector {\n    min-height: 180px;\n  }\n\n  .latest_resources {\n    padding: 40px 0px;\n  }\n\n  .center-image-wrapper .center-image {\n    margin: 12px auto 0;\n  }\n\n  .herobanner2 .banner_cnt h3 {\n    font-size: 30px;\n  }\n\n  .herobanner2 .banner_cnt h1 {\n    font-size: 24px;\n  }\n\n  .newhome_maximizeprofit_s .trusted_partner {\n    padding: 60px 0px;\n  }\n\n\n}\n\n\n@media screen and (max-width:767px) {\n\n  .vector_currency img {\n    width: 20px;\n    opacity: 0.7;\n  }\n\n  .trending_crypto .landing_pair_symbol {\n    font-size: 13px;\n  }\n\n  .banner_img {\n    width: 300px !important;\n  }\n\n  body .newhome_maximizeprofit_s .row.cta_register_s {\n    margin-top: 15px;\n  }\n\n  .services_block p {\n    line-height: 20px;\n    padding-top: 5px;\n  }\n\n  .herobanner2 .banner_cnt h1 {\n    font-size: 18px;\n  }\n\n  .herobanner2 .banner_cnt h3 {\n    font-size: 22px;\n  }\n\n  .how_get_account_ot ul li p {\n    font-size: 15px;\n  }\n\n  .herobanner2 .scan_block {\n    margin: -20px auto;\n  }\n\n  .rounded_effect_bottom {\n    display: none;\n  }\n\n  .banner_add_slide .heighlightcnt img {\n    height: 100%;\n  }\n\n  .hero_section.herobanner2 {\n    padding-bottom: 0px;\n  }\n\n  .trading_img {\n    right: inherit;\n    text-align: center;\n    left: inherit;\n    margin: 0 auto;\n    position: relative;\n    top: 0px;\n  }\n\n  .services_block {\n    text-align: center;\n    align-items: center;\n  }\n\n  .how_get_account_ot .row .col-sm-4 {\n    width: 100%;\n  }\n\n  .how_get_account_ot .row .col-sm-8 {\n    width: 100%;\n  }\n\n  .services_block h4 {\n    font-size: 18px;\n    margin-top: 24px;\n  }\n\n  .newhome_maximizeprofit_s .profit_cost_cnt {\n    text-align: center;\n  }\n\n  .newhome_maximizeprofit_s .row .col-sm-4 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s .row .col-sm-8 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s button.learnbtn {\n    margin: 0 auto;\n  }\n\n  .newhome_maximizeprofit_s .trade_btn button {\n    margin: 0 auto;\n  }\n\n  .how_get_account_ot .row .col-sm-6 {\n    width: 100%;\n  }\n\n  .main_marker_summary .row.align-items-center .col-sm-8 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s .trusted_partner {\n    padding: 30px 0px 10px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {\n    padding-top: 0px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s {\n    margin-top: 30px;\n  }\n\n  .newhome_maximizeprofit_s {\n    padding-top: 15px;\n  }\n\n  .newhome_maximizeprofit_s::after {\n    background-size: 300px;\n    opacity: 0.5;\n  }\n\n  .services_block {\n    min-height: 100%;\n  }\n\n  .newhome_maximizeprofit_s .cta_vector {\n    padding-top: 24px;\n  }\n\n  .how_get_account_ot.trade_app__app {\n    padding-top: 15px;\n  }\n\n  .trending_crypto .landing_pair_price {\n    font-size: 13px;\n  }\n\n  .trending_crypto .landing_pair_chg {\n    font-size: 12px;\n  }\n\n\n}\n\n@media screen and (max-width:767px) {\n\n  #popup-box.popup-box.homepop_box {\n    width: 70%;\n  }\n\n  .trade_platform_section ul.trade_platform_cards_grid li .platform_vector,\n  .trade_platform_section .trade_platform_slide_card .platform_vector {\n    min-height: 100px;\n  }\n\n  .vector_currency img {\n    width: 20px;\n    opacity: 0.7;\n  }\n\n  .services_block p {\n    line-height: 20px;\n    padding-top: 5px;\n  }\n\n  .herobanner2 .banner_cnt h1 {\n    font-size: 18px;\n  }\n\n\n\n  .herobanner2 .banner_cnt h3 {\n    font-size: 22px;\n  }\n\n  .how_get_account_ot ul li p {\n    font-size: 15px;\n  }\n\n  .herobanner2 .scan_block {\n    margin: -20px auto;\n  }\n\n  .rounded_effect_bottom {\n    display: none;\n  }\n\n  .banner_add_slide .heighlightcnt img {\n    height: 100%;\n  }\n\n  .hero_section.herobanner2 {\n    padding-bottom: 0px;\n  }\n\n  .trading_img {\n    right: inherit;\n    text-align: center;\n    left: inherit;\n    margin: 0 auto;\n    position: relative;\n    top: 0px;\n  }\n\n  .services_block {\n    text-align: center;\n    align-items: center;\n  }\n\n  .how_get_account_ot .row .col-sm-4 {\n    width: 100%;\n  }\n\n  .how_get_account_ot .row .col-sm-8 {\n    width: 100%;\n  }\n\n  .services_block h4 {\n    font-size: 18px;\n    margin-top: 24px;\n  }\n\n  .newhome_maximizeprofit_s .profit_cost_cnt {\n    text-align: center;\n  }\n\n  .newhome_maximizeprofit_s .row .col-sm-4 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s .row .col-sm-8 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s button.learnbtn {\n    margin: 0 auto;\n  }\n\n  .newhome_maximizeprofit_s .trade_btn button {\n    margin: 0 auto;\n  }\n\n  .how_get_account_ot .row .col-sm-6 {\n    width: 100%;\n  }\n\n  .main_marker_summary .row.align-items-center .col-sm-8 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s .trusted_partner {\n    padding: 30px 0px 10px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {\n    padding-top: 0px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s {\n    margin-top: 30px;\n  }\n\n  .newhome_maximizeprofit_s {\n    padding-top: 15px;\n  }\n\n  .newhome_maximizeprofit_s::after {\n    background-size: 300px;\n    opacity: 0.5;\n  }\n\n  .services_block {\n    min-height: 100%;\n  }\n\n  .newhome_maximizeprofit_s .cta_vector {\n    padding-top: 24px;\n  }\n\n  .how_get_account_ot.trade_app__app {\n    padding-top: 15px;\n  }\n\n\n}\n\n@media (max-width: 991.98px) {\n  .features-hub-center {\n    min-height: 320px;\n  }\n\n  .feature-connector-hit {\n    display: none;\n  }\n\n  .top-left-pos,\n  .bottom-left-pos,\n  .top-right-pos,\n  .bottom-right-pos {\n    transform: none;\n  }\n}\n\n/* —— trade_platform_section: desktop = grid <ul>; mobile (≤991px) = react-slick —— */\n.trade_platform_slider_wrap {\n  display: none;\n}\n\n.trade_platform_section .trade_platform_slide_card {\n  width: 100%;\n  border: 1px solid #ffffff14;\n  background-color: #ffffff15;\n  padding: 24px;\n  border-radius: 12px;\n  transition: all 0.5s;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.trade_platform_section .trade_platform_slide_card:hover {\n  background-color: #d1aa6740;\n  border: 1px solid #d1aa67;\n  box-shadow: 0 0 30px #d1aa67;\n}\n\n.trade_platform_section .trade_platform_slide_card .platform_vector {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.trade_platform_section .trade_platform_slide_card .platform_vector img {\n  max-width: 160px;\n}\n\n.trade_platform_section .trade_platform_slide_card h3 {\n  font-size: 20px;\n}\n\n.trade_platform_section .trade_platform_slide_card p {\n  font-size: 16px;\n  color: #ffffff70;\n  margin: 20px 0 0;\n}\n\n@media screen and (max-width:580px) {\n\n  #popup-box.popup-box.homepop_box {\n    width: 85%;\n  }\n\n  .trending_crypto_tabs button {\n    font-size: 13px;\n  }\n\n  .viewmorebtn a {\n    font-size: 14px;\n  }\n\n}\n\n@media screen and (max-width: 991.98px) {\n  .trade_platform_section ul.trade_platform_cards_grid {\n    display: none !important;\n  }\n\n  .trade_platform_slider_wrap {\n    display: block;\n    margin-top: 20px;\n    padding-bottom: 4px;\n  }\n\n  .trade_platform_slider_wrap .slick-list {\n    margin: 0 -8px;\n  }\n\n  .trade_platform_slider_wrap .slick-slide>div {\n    padding: 0 8px;\n  }\n\n  .trade_platform_section .trade_platform_slide_card p {\n    font-size: 15px;\n    margin: 12px 0 0;\n  }\n}\n\n.trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots,\n.trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots {\n  position: relative;\n  bottom: auto;\n  margin-top: 16px;\n  display: flex !important;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li,\n.trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li {\n  height: auto;\n  margin: 0;\n  width: auto;\n}\n\n.trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li button,\n.trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li button {\n  width: auto;\n  height: auto;\n  padding: 0;\n}\n\n.trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li button:before,\n.trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li button:before {\n  font-size: 0;\n  width: 8px;\n  height: 8px;\n  border-radius: 50px;\n  background: #ffffff50;\n  opacity: 1;\n  left: 0;\n  top: 0;\n  content: \"\";\n}\n\n.trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li.slick-active button:before,\n.trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li.slick-active button:before {\n  width: 12px;\n  background: #d1aa67;\n}\n\nbody.light_theme .trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li button:before,\nbody.light_theme .trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li button:before {\n  background: #bfc1c9b0;\n}\n\nbody.light_theme .trade_platform_slider_wrap .slick-dots.trade_platform_slick_dots li.slick-active button:before,\nbody.light_theme .trade_platform_slider_wrap ul.slick-dots.trade_platform_slick_dots li.slick-active button:before {\n  background: #d1aa67;\n}\n\n/* latest_resources: desktop = 3 columns; mobile / tablet (≤991px) = tab strip + one card (like trending_crypto) */\n.latest_resources_tabs {\n  display: none;\n}\n\n@media screen and (max-width: 991.98px) {\n  .latest_resources_tabs {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: stretch;\n    flex-wrap: nowrap;\n    gap: 24px;\n    width: 100%;\n    margin-top: 16px;\n    margin-bottom: 8px;\n    padding: 0 4px;\n  }\n\n  .cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li button,\n  .cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li button {\n    width: 15px;\n    height: 5px;\n  }\n\n  .cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots li.slick-active button:before,\n  .cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots li.slick-active button:before {\n    width: 16px;\n  }\n\n  .cardbnr_crypto_slide .slick-dots.cardbnr_slick_dots,\n  .cardbnr_crypto_slide ul.slick-dots.cardbnr_slick_dots {\n    margin: 12px 0px 0px;\n  }\n\n  .latest_resources_tabs button {\n    flex: inherit;\n    min-width: 0;\n    margin: 0;\n    padding: 8px 4px;\n    font-size: 13px;\n    position: relative;\n    font-weight: 500;\n    line-height: 1.2;\n    border: none;\n    background: none;\n    color: #5c5c5c;\n    cursor: pointer;\n    transition: color 0.2s ease, opacity 0.2s ease;\n  }\n\n  .latest_resources_tabs button::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 18px;\n    height: 2.5px;\n    background: #2c2c2c;\n    margin: 0 auto;\n    border-radius: 20px;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n  }\n\n  .latest_resources_tabs button.active::before {\n    opacity: 1;\n  }\n\n  .latest_resources_tabs button.active {\n    color: #000000;\n  }\n\n  .latest_resources_cards_row>.latest_resources_col {\n    display: none !important;\n  }\n\n  .latest_resources_cards_row>.latest_resources_col.active {\n    display: block !important;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .latest_resources_cards_row .resources_news {\n    min-height: 0;\n  }\n}\n\nbody.light_theme .latest_resources_tabs button {\n  color: #84888c;\n}\n\nbody.light_theme .latest_resources_tabs button.active {\n  color: #0d0d0d;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
